import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxUploaderModule } from 'ngx-uploader';
import { SharedModule } from 'src/app/shared/shared.module';
import { ContentBlocksModule } from '../../content-blocks.module';
import { ContentUploadInputComponent } from './content-upload-input.component';
import { MaterialModule } from 'src/app/material.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
  declarations: [
    ContentUploadInputComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatProgressBarModule,
    ContentBlocksModule,
    NgxUploaderModule
  ],
  exports: [
    ContentUploadInputComponent
  ]
})
export class ContentUploadInputModule { }
